import { Waypoint } from "vue-waypoint";

export default {
  name: "VenueIntroduction",
  props: {
    data: Object,
  },
  components: {
    Waypoint,
  },
  created() {},
};
